export default {"src":"/_next/static/media/star.638db8a1.svg","height":18,"width":14,"blurWidth":0,"blurHeight":0};